import React from 'react';
import {
  Container,
  Flex,
  Text,
  Stack,
  Heading,
  Image
} from '@chakra-ui/react';
import { COLORS } from "../../../colors";

const Section = ({ imageSrcs, title, description, imageOnRight }) => {
  return (
    <Stack direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} spacing={10}>
      <Flex
        p={8}
        flex={1}
        align={'top'}
        justify={'center'}
        order={{ base: 1, md: imageOnRight ? 2 : 1 }}
      >
        <Stack spacing={6} w={'full'} maxW={'lg'} vertical-align={'top'}>
          <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"} color={COLORS.brand1}>
            {title}
          </Heading>
          <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            {description}
          </Text>
        </Stack>
      </Flex>
      <Flex
        flexDirection='column'
        flex={1}
        order={{ base: 2, md: imageOnRight ? 1 : 2 }}
      >
        {imageSrcs.map((src, index) => (
          <Image
            key={index}
            alt={'Section Image'}
            objectFit={'cover'}
            src={src}
            maxH={{ base: '400px', md: '400px' }} // Ajusta esta altura según lo deseado
            w={'100%'}
            mb={0} // Margin bottom for spacing between images
          />
        ))}
      </Flex>
    </Stack>
  );
};



const Movers = () => {
  return (
    <Section
      imageSrcs={["/movers1.jpg"]}
      title="MOVERS (8-9 años)"
      description="Curso de inglés para niños de 8-9 años con profesores nativos-bilingües titulados. Con esta edad, los niños ya se han acostumbrado a tener una clase totalmente en inglés. Han aprendido a comunicarse sobre cosas sencillas con su profesor y han progresado mucho en la lectura y escritura en inglés. Estos alumnos tienen entre 8 y 9 años y ya han empezado a ver un poco de gramática en los libros. Como en los demás cursos de niños de Nessie, practicamos todos los temas con juegos y actividades para que aprendan el inglés de una forma natural y divertida."
      imageOnRight={true}
    />
  );
};

const Flyers = () => {
  return (
    <Section
      imageSrcs={["/flyers.jpg"]}
      title="FLYERS (9-11 años)"
      description="Equivale a un nivel A2, pero con contenidos diseñados para niños de estas edades. Durante este curso, adquieren una buena base de gramática, dominan el inglés bastante bien y empezamos a enseñarles cómo organizar sus ideas escritas en inglés. Como en todos nuestros cursos se practican todos los temas con otros juegos y actividades para que aprendan de una forma natural y divertida."
      imageOnRight={false}
    />
  );
};

const Primaria = () => {
  return (
    
      <Stack direction="column" fontFamily={"Montserrat"} spacing={10}>
        <Flyers />
      </Stack>
    
  );
};

export default Primaria;
